import React, {Component} from "react";
import './listpage.scss';
// import TopNavbar from "./components/navbar";

class ListPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            listContent:{},
            category:null,
        }
      }

componentDidMount(){
    const list = JSON.parse(JSON.stringify(this.props.filter))
    // alert(_rand)
    this.setState({listContent:list})
}

  render(){

    return (
      <div className="listpage-main">

        <div className="listpage-title-bar">   
            <div className="text-wrapper">
                {"browse our product"}  
            </div>
        </div>

        <div className="title-bar">
            <div className="img-wrapper">
                <img src="" width="100%" />
            </div>
            <div className="text-wrapper">
               <div className="text-item" style={{width:"50%"}}>{"Name of Product"}</div>
               {/* <div className="text-item" style={{width:"50%"}}>{"Description"}</div> */}
               <div className="text-item" style={{width:"50%"}}>{"Price (USD)"}</div>
            </div>
        </div>

        {
            Object.keys(this.state.listContent).map((i)=>{
                return(
                    <div className="item-bar" onClick={(e)=>{
                        this.props.setval({
                            chosenProduct:{
                                "cat":this.state.listContent[i]["parentCategory"],
                                "item":i,
                            },
                            currentPage:"detailpage",
                            previousView: "listpage",
                        })
                    }}>
                    <div className="img-wrapper">
                        <img src={"/assets/"+this.state.listContent[i]["parentCategory"]+"-"+i+"-1.PNG"} width="100%" />
                    </div>
                    <div className="text-wrapper">
                       <div className="text-item" style={{width:"50%"}}>{this.state.listContent[i]["name"]}</div>
                       {/* <div className="text-item" style={{width:"50%"}}>{this.state.listContent[i]["description"]}</div> */}
                       <div className="text-item" style={{width:"50%"}}>{(typeof(this.props.filter[i]["price"])==="object")?
                       "starting from USD "+this.props.filter[i]["price"]["small"]:"USD    "+this.props.filter[i]["price"]}</div>
                    </div>
                </div>
                )
            })
        }

        {/* <div className="item-bar">
            <div className="img-wrapper">
                <img src="/assets/wallart-item1-1.PNG" width="100%" />
            </div>
            <div className="text-wrapper">
               <div className="text-item">{this.props.productList["wallart"]["item1"]["name"]}</div>
               <div className="text-item">{this.props.productList["wallart"]["item1"]["description"]}</div>
               <div className="text-item">{this.props.productList["wallart"]["item1"]["price"]}</div>
            </div>
        </div> */}


      </div>
    );


  }
}

export default ListPage;
